import styled from 'styled-components';
import { Spinner as BootstrapSpinner } from 'react-bootstrap';

const Spinner = styled(BootstrapSpinner)`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    color: white;

    margin: auto;
    padding: 0;
`;

export default Spinner;
